import { LIMITS, parseProjectJson, type Project } from '@rcs/data-schema';
import { toProjectFile } from './file';

/** 書き出すファイルの拡張子。 */
export const EXPORT_EXTENSION = '.rcs.json';

/** プロジェクトを、書き出し用の JSON 文字列にする（FR-CRS-007）。 */
export function exportProjectJson(project: Project): string {
  return JSON.stringify(toProjectFile(project), null, 2);
}

/** 書き出すファイル名。ファイル名に使えない文字は `_` にする。 */
export function exportFileName(project: Project): string {
  const base = Array.from(project.name, (char) =>
    char.charCodeAt(0) < 0x20 || '\\/:*?"<>|'.includes(char) ? '_' : char,
  )
    .join('')
    .trim();
  return `${base === '' ? 'project' : base}${EXPORT_EXTENSION}`;
}

/** 読み込みの結果。失敗のときは、利用者に見せる理由の一覧（日本語）を返す。 */
export type ImportResult =
  | { readonly ok: true; readonly project: Project }
  | { readonly ok: false; readonly reasons: readonly string[] };

/**
 * 読み込んだファイルの大きさを、読む前に検査する（NFR-SEC-003）。
 * 上限を超えるときは理由、問題なければ `undefined`。
 */
export function checkImportSize(bytes: number): string | undefined {
  return bytes > LIMITS.maxFileBytes
    ? `ファイルが大きすぎます（上限 ${String(LIMITS.maxFileBytes / 1024 / 1024)} MB）`
    : undefined;
}

/** JSON の文字列を検証して、プロジェクトとして読み込む。コードや外部参照は実行しない（NFR-SEC-004）。 */
export function importProjectText(text: string): ImportResult {
  const parsed = parseProjectJson(text);
  if (parsed.ok) return { ok: true, project: parsed.value.project };
  const { error } = parsed;
  return {
    ok: false,
    reasons: error.kind === 'invalid' ? [error.message, ...error.issues] : [error.message],
  };
}
